module.exports = __webpack_public_path__ + "static/media/1.2bf67c2c.png";